var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ele-page flex-n fac fje"},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"pager-count":7,"page-sizes":[10, 20, 50, 100],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }